var path = 'areas/projects/views/pulse.html';
var html = "<div class=project-pulse ng-class=pulseFreshnessClass()> <div ng-show=anyPulse() class=pulse-time>{{ pulse.Deployed | momentAgo }}</div> <div ng-show=anyPulse() class=pulse-environment>{{ pulse.EnvironmentName }}</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/pulse.html
// module id = 946
// module chunks = 1